import React from 'react';
import Translation from '../General/Translation';

const ElbenWaldContentMenu = ({translation, affiliateSlug, setShowMenu})=>{
        return (
            <div className="elbenwald-container">
                    <div className="elbenwald-wrapper links-wrapper">
                        <div className='elbenwald-menu-wrapper'>
                            <a className='elbenwald-link' target="_blank" href={'https://www.elbenwald.de/?partner=' + affiliateSlug}>
                                <span className='text-medium-navigation'>
                                    <Translation id="go_to_shop" trans={translation}>Zum Shop</Translation>
                                </span>
                            </a>

                            <a className='elbenwald-link' target="_blank" href={'https://www.elbenwald.de/angebote?partner=' + affiliateSlug}>
                                <span className='text-medium-navigation'>
                                    <Translation id="merch_sale" trans={translation}>Angebote</Translation>
                                </span>
                            </a>

                            <a className='elbenwald-link' target="_blank" href={'https://www.elbenwald.de/neu?partner=' + affiliateSlug}>
                                <span className='text-medium-navigation'>
                                    <Translation id="merch_new" trans={translation}>NEU</Translation>
                                </span>
                            </a>

                            <a className='elbenwald-link' target="_blank" href={'https://www.elbenwald.de/filme-serien?partner=' + affiliateSlug}>
                                <span className='text-medium-navigation'>
                                    <Translation id="merch_movie_series" trans={translation}>Filme & Serien</Translation>
                                </span>
                            </a>

                            <a className='elbenwald-link' target="_blank" href={'https://www.elbenwald.de/anime?partner=' + affiliateSlug}>
                                <span className='text-medium-navigation'>
                                    <Translation id="merch_anime" trans={translation}>Anime</Translation>
                                </span>
                            </a>
                           
                            <a className='elbenwald-link' target="_blank" href={'https://www.elbenwald.de/gaming?partner=' + affiliateSlug}>
                                <span className='text-medium-navigation'>
                                    <Translation id="merch_gaming" trans={translation}>Gaming</Translation>
                                </span>
                            </a>
                            
                            <button className='elbenwald-link' onClick={()=> setShowMenu(false)}>
                                <span className='text-medium-navigation'>
                                    <Translation id="close" trans={translation}>Schließen</Translation>
                                </span>
                            </button>
                        </div>
                    </div>

                    <div className="elbenwald-wrapper brands-wrapper">
                        <a className='elbenwald-link brands harry-potter-wrapper' target="_blank" href={'https://www.elbenwald.de/harry-potter?partner=' + affiliateSlug}>
                            <span className='text-medium-navigation harry-potter'>
                                <span className="screen-reader-text">Harry Potter</span>
                            </span>
                        </a>

                        <a className='elbenwald-link brands star-wars-wrapper' target="_blank" href={'https://www.elbenwald.de/star-wars?partner=' + affiliateSlug}>
                            <span className='text-medium-navigation star-wars'>
                                <span className="screen-reader-text">Star Wars</span>
                            </span>
                        </a>

                        <a className='elbenwald-link brands herr-der-ringe-wrapper' target="_blank" href={'https://www.elbenwald.de/herr-der-ringe?partner=' + affiliateSlug}>
                            <span className='text-medium-navigation herr-der-ringe'>
                                <span className="screen-reader-text">Herr der Ringe</span>
                            </span>
                        </a>

                        <a className='elbenwald-link brands naruto-wrapper' target="_blank" href={'https://www.elbenwald.de/naruto?partner=' + affiliateSlug}>
                            <span className='text-medium-navigation naruto'>
                                <span className="screen-reader-text">Naruto</span>
                            </span>
                        </a>

                        <a className='elbenwald-link brands disney-wrapper' target="_blank" href={'https://www.elbenwald.de/disney?partner=' + affiliateSlug}>
                            <span className='text-medium-navigation disney'>
                                <span className="screen-reader-text">Disney</span>
                            </span>
                        </a>

                        <a className='elbenwald-link brands marvel-wrapper' target="_blank" href={'https://www.elbenwald.de/marvel?partner=' + affiliateSlug}>
                            <span className='text-medium-navigation marvel'>
                                <span className="screen-reader-text">Marvel</span>
                            </span>
                        </a>

                        <a className='elbenwald-link brands pokemon-wrapper' target="_blank" href={'https://www.elbenwald.de/pokemon?partner=' + affiliateSlug}>
                            <span className='text-medium-navigation pokemon'>
                                <span className="screen-reader-text">Pokemon</span>
                            </span>
                        </a>

                        <a className='elbenwald-link brands guardians-of-the-galaxy-wrapper' target="_blank" href={'https://www.elbenwald.de/guardians-of-the-galaxy?partner=' + affiliateSlug}>
                            <span className='text-medium-navigation guardians-of-the-galaxy'>
                                <span className="screen-reader-text">Guardians of the Galaxy</span>
                            </span>
                        </a>

                        <a className='elbenwald-link brands demon-slayer-wrapper' target="_blank" href={'https://www.elbenwald.de/demon-slayer?partner=' + affiliateSlug}>
                            <span className='text-medium-navigation demon-slayer'>
                                <span className="screen-reader-text">Demon Slayer</span>
                            </span>
                        </a>

                        <a className='elbenwald-link brands witcher-wrapper' target="_blank" href={'https://www.elbenwald.de/witcher?partner=' + affiliateSlug}>
                            <span className='text-medium-navigation witcher'>
                                <span className="screen-reader-text">The Witcher</span>
                            </span>
                        </a>

                        <a className='elbenwald-link brands lilo-stitch-wrapper' target="_blank" href={'https://www.elbenwald.de/lilo-stitch?partner=' + affiliateSlug}>
                            <span className='text-medium-navigation lilo-stitch'>
                                <span className="screen-reader-text">Lilo & Stitch</span>
                            </span>
                        </a>

                        <a className='elbenwald-link brands zelda-wrapper' target="_blank" href={'https://www.elbenwald.de/zelda?partner=' + affiliateSlug}>
                            <span className='text-medium-navigation zelda'>
                                <span className="screen-reader-text">The Legend of Zelda</span>
                            </span>
                        </a>

                        <a className='elbenwald-link brands one-piece-wrapper' target="_blank" href={'https://www.elbenwald.de/one-piece?partner=' + affiliateSlug}>
                            <span className='text-medium-navigation one-piece'>
                                <span className="screen-reader-text">One Piece</span>
                            </span>
                        </a>

                        <a className='elbenwald-link alle-marken' target="_blank" href={'https://www.elbenwald.de/alle-marken?partner=' + affiliateSlug}>
                            <span className='text-medium-navigation'>
                                <Translation id="all_brands" trans={translation}>Alle Marken</Translation>
                            </span>
                        </a>
                    </div>
            </div>
        );
};

export default ElbenWaldContentMenu;


